import { Component, EventEmitter, OnInit, Output, Input, DestroyRef, inject, ChangeDetectorRef } from '@angular/core';
import { FeedsService } from '../../services/feeds/feeds.service';
import { AccountsService } from '../../services/accounts/accounts.service';
import { LoginService } from '../../services/login/login.service';
import { ActivatedRoute } from '@angular/router';
import { LtmsEventHandlerService } from '../../services/ltms-event-handler/ltms-event-handler.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import * as moment from 'moment';
import { extendedRaterFile } from "src/app/shared/services/external-ts-files/extended-rating-mapper";
import { NgFor, NgIf } from '@angular/common';
import { ResponsePanelComponent } from './sub-components/response-panel/response-panel.component';
import { InformationPanelComponent } from './sub-components/information-panel/information-panel.component';
import { ChatPanelComponent } from './sub-components/chat-panel/chat-panel.component';
import { HistoryPanelComponent } from './sub-components/history-panel/history-panel.component';
import { RelationshipViewPanelComponent } from './sub-components/relationship-view-panel/relationship-view-panel.component';
import { LtmsLoaderComponent } from '../ltms-loader/ltms-loader.component';
import { LtmsErrorComponent } from '../ltms-error/ltms-error.component';
import { HelpersService } from '../../services/helpers/helpers.service';

@Component({
    selector: 'app-feed-detail-panel',
    templateUrl: './feed-detail-panel.component.html',
    styleUrls: ['./feed-detail-panel.component.scss'],
    imports: [NgFor, NgIf, ResponsePanelComponent, InformationPanelComponent, ChatPanelComponent, HistoryPanelComponent, RelationshipViewPanelComponent, LtmsLoaderComponent, LtmsErrorComponent]
})
export class FeedDetailPanelComponent implements OnInit {
    @Input() fullscreen: boolean = false;
    @Output() onPageChange: any = new EventEmitter<any>();
    destroyRef = inject(DestroyRef);
    tabVisblity: any = {
        chat: Helpers.isTabVisible(false, 'inbox', 'chat'),
        history: Helpers.isTabVisible(false, 'inbox', 'history'),
        profile: Helpers.isTabVisible(false, 'profile', 'profile'),
        siblings: Helpers.isTabVisible(false, 'inbox', 'siblings'),
    }
    responseTab = {
        name: "Response",
        key: "response",
        order: 1
    }
    infoTab = {
        name: "Information",
        key: "information",
        order: 2
    }

    chatTab = {
        name: "Chat",
        key: "chat",
        order: 3
    }

    historyTab = {
        name: "History",
        key: "history",
        order: 4
    }
    tabList: any = []

    relationshipView: any = {
        name: "Relationship view",
        key: "relationshipView",
        tab_type: 'beta',
        type_text: 'Beta',
        order: 5
    }
    tabs: any = []//this.tabList;
    activeTab: any = {
        name: "Response",
        key: "response",
        order: 1
    }
    feedIndex: number = 0;
    feedCount: number = 0;
    feedData: any = {};
    brandDetails: any = {};
    isPagingEnabled: boolean = false;
    feedId: string = "";
    projectId: string = "";
    isPanelOpen: boolean = false
    hasPrimaryRating: boolean = false;
    isPrimaryQuestionDeleted: boolean = false;
    isTSEnabled: boolean = false;
    replyBackAllowed: boolean = false;
    isFeedDataAvailable: boolean = false;
    isFeedLoaded: boolean = false;
    managerAccess: any = [];
    loginResponse: any = {};
    error_code: string = '404';
    feedIdList: any = [];
    pagingDetails: any = {};
    pagingButtons: any = {
        isNextBtnEnabled: true,
        isPreviousbtnEnabled: true,
        isNext: false,
        isPrevious: false
    }
    isAccount: boolean = false
    isReload: boolean = false;
    isVerbatim: boolean = false;
    isDataLoaded: boolean = false;

    extenderRatingMapper = new extendedRaterFile();

    constructor(
        private _routes: ActivatedRoute,
        public _feedService: FeedsService,
        private _accountService: AccountsService,
        private _login: LoginService,
        private ltmsEvent: LtmsEventHandlerService,
        private _helpers: HelpersService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.ltmsEvent.remove('feed-detail-panel');
        this.ltmsEvent.listen('feed-detail-panel', (event: any) => {
            this.isFeedDataAvailable = false;
            this.isFeedLoaded = false;
            if (_.get(event, 'data.feed_id') && _.get(event, 'data.feed_id') != this.feedId) {
                this.feedId = _.get(event, 'data.feed_id');
                this.isVerbatim = _.get(event, 'data.isVerbatim', false);
                this.feedIdList = _.get(event, 'data.feedIdList', []);
                this.pagingDetails = _.get(event, 'data.pagingDetails', {});
                this.setActiveTabs()
                this.togglePagingButtons()

                if (this.feedId) {
                    this._login.getManagerDetails().pipe(
                        takeUntilDestroyed(this.destroyRef)
                    ).subscribe((response: any) => {
                        if (response.code == 0 && !_.isEmpty(response.data)) {
                            this.loginResponse = response.data;
                            this.isFeedDataAvailable = false;
                            this.isFeedLoaded = false;
                            this.initialize(this.feedId)
                        } else {
                            this._login.logout();
                        }
                    })
                }
            }

        });
        this.ltmsEvent.remove('refresh-feed-detail');
        this.ltmsEvent.listen('refresh-feed-detail', () => {
            this.isReload = true;
            this.initialize(this.feedId)
        });

        this.ltmsEvent.remove('feed-detail-loaded');
        this.ltmsEvent.listen('feed-detail-loaded', () => {
            this.isDataLoaded = true;
        });
    }

    setActiveTabs() {
        this.tabs = [];
        this.tabList = []
        this.isDataLoaded = false;
        this.tabVisblity = {
            chat: Helpers.isTabVisible(false, 'inbox', 'chat'),
            history: Helpers.isTabVisible(false, 'inbox', 'history'),
            profile: Helpers.isTabVisible(false, 'inbox', 'profile'),
            siblings: Helpers.isTabVisible(false, 'inbox', 'siblings'),
        }

        this.tabs.push(this.responseTab)
        this.tabList.push(this.responseTab);

        if (this.tabVisblity.profile) {
            this.tabs.push(this.infoTab);
            this.tabList.push(this.infoTab);
        }


        if (this.tabVisblity.chat) {
            this.tabs.push(this.chatTab);
            this.tabList.push(this.chatTab);
        }


        if (this.tabVisblity.history) {
            this.tabs.push(this.historyTab);
            this.tabList.push(this.historyTab);
        }

        // if (this.tabVisblity.siblings) {
        //     this.tabs.push(this.relationshipView);
        //     this.tabList.push(this.relationshipView);
        // }
        this.tabs = _.uniqBy(this.tabs, 'key')
        this.activeTab = this.tabs[0];

        this.isAccount = (_.hasIn(Helpers, 'isAccount') && Helpers.isAccount) ? true : false;


        if (_.hasIn(Helpers, 'isAccount') && Helpers.isAccount) {
            this.tabs = _.filter(Helpers.deepClone(this.tabList), (obj: any) => {
                return obj.key != 'relationshipView';
            })
        }
    }

    initialize(feedId: string, isChatPanel?: boolean) {
        this.isDataLoaded = false;
        this._feedService.showFeedDetails.set(true)
        if (!isChatPanel) {
            if (this.feedIdList && this.feedIdList.length) {
                this.feedIndex = this.feedIdList.indexOf(feedId);
                if (this.isVerbatim) {
                    this.feedCount = this.feedIndex + 1
                } else {
                    this.feedCount = ((this.pagingDetails.pageNumber - 1) * this.pagingDetails.pageSize) + this.feedIndex + 1;
                }

            }
            this.togglePagingButtons();
        }

        this.getFeedDatail(feedId);
    }


    getFeedDatail(feedId: string) {
        this._feedService.getFeedDetails(feedId).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res: any) => {
            if (res.code == 0 && _.hasIn(res, 'data.feed') && !_.isEmpty(res.data.feed)) {
                const brandId = _.get(res, 'data.feed.brand_id');
                this.feedId = _.get(res, 'data.feed._id', '');
                if (this.isReload || brandId && (_.isEmpty(this.brandDetails) || this.brandDetails._id != brandId)) {
                    this.isReload = false;
                    this._accountService.getBrandDetail(brandId).pipe(
                        takeUntilDestroyed(this.destroyRef)
                    ).subscribe((response) => {
                        if (response.code == 0 && _.hasIn(response, 'data.brand') && !_.isEmpty(response.data.brand)) {
                            this.initModuleConfig(response.data.brand).then(() => {
                                if (!(_.hasIn(Helpers, 'isAccount') && Helpers.isAccount) && _.hasIn(response, 'data.brand.relationship_view')) {
                                    // const relationshipView = _.find(this.tabList,{key:'relationshipView'});
                                    // if(!relationshipView)
                                    //     this.tabList.push(this.relationshipView);

                                    this.addRemoveRelationShipViewTab(response.data.brand)
                                } else {
                                    this.tabs = _.filter(Helpers.deepClone(this.tabList), (obj: any) => {
                                        return obj.key != 'relationshipView';
                                    })
                                }
                                this.prepareData(res.data, response.data.brand);
                                this.isFeedDataAvailable = true;
                                this.isFeedLoaded = true
                                this.cdr.detectChanges();
                            })
                        } else {
                            this.isFeedDataAvailable = false;
                            this.isFeedLoaded = true;
                            this.error_code = '404'
                            this.cdr.detectChanges();
                        }
                    })
                } else if (!_.isEmpty(this.brandDetails) && this.brandDetails._id == brandId) {
                    this.addRemoveRelationShipViewTab(this.brandDetails)
                    this.prepareData(res.data, this.brandDetails);
                    this.isFeedDataAvailable = true;
                    this.isFeedLoaded = true
                    this.cdr.detectChanges();
                } else {
                    console.error("Brand id not found in feed details.")
                    this.isFeedDataAvailable = false;
                    this.isFeedLoaded = true
                    this.error_code = '404'
                    this.cdr.detectChanges();
                }
            } else {
                this.isFeedDataAvailable = false
                this.isFeedLoaded = true;
                this.error_code = '404'
                this.cdr.detectChanges();
            }
        }, (error) => {
            this.isFeedDataAvailable = false
            this.isFeedLoaded = true;
            this.error_code = '500'
            this.cdr.detectChanges();
        })
    }

    initModuleConfig(brandDetails: any) {
        return new Promise((resolve) => {
            if (Helpers?.moduleConfigs && Helpers?.moduleConfigs && Helpers?.moduleConfigs?.project && !_.isEmpty(Helpers?.moduleConfigs?.project)) {
                resolve(true)
            } else {
                let moduleConfig: any = brandDetails.module_configuration_v2;
                this._accountService.getModulConfigs({ brand_id: brandDetails._id }).subscribe((response: any) => {
                    if (_.get(response, 'moduleConfig.data.code') == 0 && !_.isEmpty(response, 'moduleConfig.data.module_configuration_v2')) {
                        let moduleConfigs = _.get(response, 'moduleConfig.data.module_configuration_v2');
                        moduleConfig = (!_.isEmpty(moduleConfigs)) ? moduleConfigs : brandDetails.module_configuration_v2;
                    }
                    const module_configuration_v2 = this._helpers.getFlatenModuleConfig(moduleConfig, false);
                    this._helpers.helpers['moduleConfigs'] = module_configuration_v2;
                    window['Helpers'] = this._helpers.consoleData();
                    this.setActiveTabs();
                    resolve(true)
                })
            }

        })
    }

    prepareData(feedData: any, brandDetails: any) {
        this.brandDetails = brandDetails;
        const access = this.getDefaultAccess();
        if (!_.isEmpty(access) && _.hasIn(access, 'reply_back_allowed')) {
            this.replyBackAllowed = _.get(access, 'reply_back_allowed', false);
        }
        this.isTSEnabled = (_.hasIn(brandDetails, 'security_settings.tokenization_server.secret_key')) ? true : false;
        if (_.hasIn(brandDetails, 'detailed_feedback_items') && !_.isEmpty(brandDetails.detailed_feedback_items)) {
            const primaryQuestion = _.find(brandDetails.detailed_feedback_items, { field_id: "primary_rating" });
            this.hasPrimaryRating = (primaryQuestion) ? true : false;
            this.isPrimaryQuestionDeleted = _.get(primaryQuestion, 'is_deleted', false);
            // Check if the question is of a specific component type and if extended rater type is 4
            if (this.hasPrimaryRating && primaryQuestion.component_type == 'ltms-nps-five-star-rater' && this.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(this.brandDetails.extended_rating_mapper))) {
                if (feedData?.feed?.feed_params?.primary_rating) {
                    let primaryRating = feedData?.feed?.feed_params?.primary_rating;
                    // Get the updated distribution using dynamic mapping logic
                    feedData.feed.feed_params.primary_rating = this.extenderRatingMapper.getExtendedRaterMappingPrimaryRating(primaryRating, primaryQuestion);
                }
            }
        }

        this.feedData = feedData;
        this.feedData.feed["hasActivePrimaryRating"] = (this.hasPrimaryRating && (this.isPrimaryQuestionDeleted != true));
        this.feedData.feed["feedback_request_date"] = moment(this.feedData.feed["feedback_request_date"]).format("DD-MMM-YY HH:mm");
        this.feedData.feed["mainRaterType"] = this.brandDetails.main_rater_type;
        if (this.activeTab.key != 'response') {
            this.isDataLoaded = true;
        }
        this.cdr.detectChanges();
    }

    getDefaultAccess() {
        this.managerAccess = _.get(Helpers, 'managerDetails.manager.manager_access', [])
        let accessArray = _.filter(this.managerAccess, { account_id: this.brandDetails.account_id, has_dashboard_access: true, is_verified: true });
        let access: any = {}
        if (!_.isEmpty(accessArray)) {
            const defaultAccess = _.find(accessArray, { brand_id: this.brandDetails._id, is_default_access: true });
            const accountAccesses = _.filter(accessArray, { manager_type: 3 });
            const prejectAccesses = _.filter(accessArray, { brand_id: this.brandDetails._id });
            if (!_.isEmpty(defaultAccess)) {
                access = defaultAccess
            } else if (!_.isEmpty(prejectAccesses)) {
                access = prejectAccesses[0];
            } else if (!_.isEmpty(accountAccesses)) {
                access = accountAccesses;
                access.reply_back_allowed = true
            }
        }
        return access;
    }

    onChangeTab(tab: any) {
        this.activeTab = tab;
        // this is used for fetching latest comment on feed while switching tab to chat.
        if (this.activeTab.key == 'chat') {
            this.isReload = true;
            this.initialize(this.feedId, true)
        }
    }

    nextFeed() {
        const newIndex = this.feedIndex + 1
        if (this.feedCount <= this.pagingDetails.total) {
            if (newIndex <= this.feedIdList.length - 1) {

                this.feedId = this.feedIdList[this.feedIndex + 1];
                this.isFeedDataAvailable = false;
                this.isFeedLoaded = false;
                this.initialize(this.feedId)
            } else if (newIndex > this.feedIdList.length - 1) {
                // get next page feed details
                this.isFeedDataAvailable = false;
                this.isFeedLoaded = false;
                this.onPageChange.emit({
                    "pageNumber": this.pagingDetails.pageNumber + 1,
                    "isNext": true
                })
            }
        }

        this.togglePagingButtons()
    }

    previousFeed() {
        const newIndex = this.feedIndex - 1
        if (this.feedCount > 0) {
            if (newIndex >= 0) {
                this.feedId = this.feedIdList[newIndex];
                this.isFeedDataAvailable = false;
                this.isFeedLoaded = false;
                this.initialize(this.feedId)
            } else if (newIndex < 0) {
                // get previous page feed details
                this.isFeedDataAvailable = false;
                this.isFeedLoaded = false;
                this.onPageChange.emit({
                    "pageNumber": this.pagingDetails.pageNumber - 1,
                    "isNext": false
                })
            }
        }
        this.togglePagingButtons()
    }

    togglePagingButtons() {
        if (this.pagingDetails.total <= 1) {
            this.pagingButtons.isNextBtnEnabled = false;
            this.pagingButtons.isPreviousbtnEnabled = false;
        } else {
            this.pagingButtons.isNextBtnEnabled = true;
            this.pagingButtons.isPreviousbtnEnabled = true;
        }
        if (this.isVerbatim) {
            this.pagingButtons.isPrevious = (this.feedIndex == 0) ? false : true;
            this.pagingButtons.isNext = (this.feedIndex + 1 == this.pagingDetails.total) ? false : true;
        } else {
            if (this.pagingDetails.pageNumber == this.pagingDetails.totalpages && this.feedCount == this.pagingDetails.total) {
                this.pagingButtons.isNext = false;
            } else {
                this.pagingButtons.isNext = true;
            }

            if (this.pagingDetails.pageNumber == 1 && this.feedCount == 1) {
                this.pagingButtons.isPrevious = false;
            } else {
                this.pagingButtons.isPrevious = true;
            }
        }

    }

    closeFeedDetailPanel() {
        this.feedId = '';
        if (location.href.indexOf('feed?feed_id') > 0) {
            // this.ltmsEvent.emit('redirect-to',{
            //     manager: this.loginResponse?.manager
            // })
            this._login.redirectBasedOnAccess(this.loginResponse?.manager);
        }
        this._feedService.showFeedDetails.set(false)

    }

    // Visibale relationship view tab based on access.
    addRemoveRelationShipViewTab(brand) {
        const relationshipLevelAllowed = _.get(brand, 'relationship_view.hierarchy_levels');
        const current_level_access = _.get(Helpers, 'managerDetails.loggedInManager.group_key');
        const isAccount = (_.hasIn(Helpers, 'isAccount') && Helpers.isAccount) ? true : false;
        let index = this.tabList.findIndex(tab => tab.key === 'relationshipView');
        if (!isAccount && relationshipLevelAllowed && relationshipLevelAllowed.length && relationshipLevelAllowed.includes(current_level_access)) {
            if (index < 0) {
                this.tabList.push(this.relationshipView);
                this.tabs.push(this.relationshipView); // add relationship view tab on list
            }
        } else {
            if (index !== -1) {
                this.tabList.splice(index, 1);
                this.tabs.splice(index, 1); // Remove the tab from list
            }
        }
    }

} 
